<template>

  <div class="main">
    <div class="interface">
      <div class="container">
        <div class="u-flex u-col-top u-row-between">
          <div class="order-detail">
            <div class="title">订单详情</div>
            <div v-if="orderDetail" class="order-info">
              <div class="info-item">
                <span class="label">套餐</span>
                <span class="value">
                {{ orderDetail.order_name }}
              </span>
              </div>

            </div>
            <div v-else class="no-order">
              <div class="empty-tip">
                <i class="el-icon-document"></i>
                <p>请输入订单号并点击搜索查看订单详情</p>
              </div>
            </div>
          </div>
          <div class="api">
            <div class="title">API链接提取<span>提取IP/生成IP，获取更适用自己的API</span></div>
            <el-form class="mt30 form" label-position="left" :model="form" label-width="100px">
              <el-row :gutter="24">
                <el-col :span="15">
                  <el-form-item label="订单号">
                    <el-input v-model="form.order_sn" placeholder="请输入订单号"/>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <div class="button-group">
                    <el-button type="primary" @click="onSearchOrder">搜索</el-button>
                    <el-button type="warning" @click="onReset">重置</el-button>
                  </div>
                </el-col>

              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="地区">
                    <el-select v-model="form.res" placeholder="请选择" style="width: 200px;">
                      <el-option label="随机" value="any"></el-option>
                      <el-option v-for="item in areas" :key="item.code" :label="item.area_name" :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="数据格式">
                    <el-select v-model="form.fmt" placeholder="请选择" :disabled="!orderDetail" style="width: 200px;">
                      <el-option label="text" value="1" v-if="orderDetail &&  orderDetail.ip_type != 1"></el-option>
                      <el-option label="json" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="form.fmt == 'text'">
                  <el-form-item label="分隔符">
                    <el-select v-model="form.sp" placeholder="请选择" style="width: 200px;">
                      <el-option label="回车换行(\r\n)" value="0"></el-option>
                      <el-option label="回车(\r)" value="1"></el-option>
                      <el-option label="换行(\n)" value="2"></el-option>
                      <el-option label="tab(\t)" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="提取数量">
                    <el-input-number v-model="form.total" :min="1"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24" v-if="orderDetail && orderDetail.ip_type == 0">
                <el-col :span="12">
                  <el-form-item label="会话时间">
                    <el-input-number v-model="form.sessTime" :min="3" :max="60"/>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <!-- 新增订单信息模块 -->

            <div class="btn">
              <el-button type="primary" @click="onGenerateApiLink">生成API链接</el-button>
            </div>
            <div class="mt30 title">API链接 <span>请复制下面的链接地址，在新的浏览器或标签页打开并查看</span></div>
            <el-input class="mt30" type="textarea" v-model="url" :autosize="{ minRows: 4, maxRows: 6 }"
                      placeholder="点击上方按钮，生成API链接" :disabled="true"/>

            <div class="mt50 btn">
              <el-button type="primary" @click="onCopyLink">复制链接</el-button>
              <el-button type="primary" @click="onOpenLink">打开链接</el-button>
            </div>
          </div>
          <div class="tool">

            <dl class="roll">
              <dt class="u-flex u-row-between">
                <h3>白名单</h3>
              </dt>
              <div v-if="orderDetail">

                <dd v-for="(item) in orderDetail.whitelist">{{ item }},
                </dd>
              </div>

            </dl>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

export default {
  name: 'Interface',
  data() {
    return {
      form: {
        order_sn: '',
        sp: '',
        fmt: '',
        total: 1,
        area: ''
      },
      areas: [],
      url: '',
      rIndex: 0,
      aIndex: 0,
      orderList: [],
      orderDetail: null,
      tabList: ['TXT', 'JSON'],
    }
  },
  methods: {
    onReset() {
      this.form = {
        order_sn: '',
        sp: 0,
        fmt: 1,
        use_ip_num: 1,
        res: '',
        sessTime: 3
      },
          this.url = '',
          this.rIndex = 0,
          this.aIndex = 0,
          this.orderList = [],
          this.orderDetail = null,
          this.areas = []
    },
    onSearchOrder() {
      if (!this.form.order_sn) {
        this.$message.error('订单号为必填项！')
        return
      }
      this.$api.extract.getArea({order_sn: this.form.order_sn}).then(res => {
        this.orderDetail = res.data.row
        this.areas = res.data.areas || []
      })

    },

    onCopyLink() {
      if (this.url == '') {
        return this.$message.warning('请先生成链接')
      }
      navigator.clipboard.writeText(this.url).then(() => {
        this.$message.success('复制成功')
      }, () => {
        this.$message.error('复制失败')
      })
    },
    onOpenLink() {
      if (this.url == '') {
        return this.$message.warning('请先生成链接')
      }
      window.open(this.url, '_blank')
    },

    onGenerateApiLink() {
      this.$api.extract.generateLink(this.form).then(res => {
        this.url = res.data
        this.$message.success('生成成功')
      })
    },

  }
}
</script>

<style scoped>

.main {
  width: 100%;
  background-color: #dfe2e9;
  padding-top: 100px; /* 为固定菜单留出空间 */
  padding-bottom: 20px;
}

.interface {
  background-color: #dfe2e9;
  width: 80%;
  margin: 0px auto;
}

.api {
  padding: 20px;
  width: 872px;
  background: #fff;
  box-sizing: border-box;
  border-radius: 8px;
  box-shadow: 2px 2px 20px 6px #f0f1f5;
}

.title {
  color: #333;
  font-size: 20px;
  text-align: left;
}

.title span {
  margin-left: 20px;
  color: #999;
  font-size: 14px;
}

.btn {
  text-align: center;
}

.btn .el-button--primary {
  padding: 12px 30px;
  background: #2682ff;
}

.tool {
  margin-left: 10px;
  width: 318px;
}

.tool li {
  position: relative;
  width: 48%;
}

.tool .txt {
  position: absolute;
  top: 30px;
  left: 20px;
}

.name {
  color: #fff8ff;
  font-size: 14px;
}

.el-button--text {
  padding: 4px 0;
  color: #fff;
  font-size: 12px;
}

::v-deep.el-button--text span {
  display: flex;
  align-items: center;
}

.dot {
  margin-right: 4px;
  width: 8px;
  height: 8px;
  line-height: 3px;
  display: block;
  text-align: center;
  border-radius: 4px;
  background: #fff;
}

.dot::before {
  content: '';
  width: 4px;
  height: 4px;
  display: inline-block;
  border-radius: 2px;
  background: #2282ff;
}

.tool li img {
  width: 100%;
  display: block;
}

.tool dl {
  margin-top: 10px;
  overflow: hidden;
  background: #fcfafb;
  border-radius: 4px;
}

.tool dl dt {
  padding: 8px 10px;
  background: #f5f5f5;
}

.tool dl dt h3 {
  color: #000;
  font-size: 14px;
}

.tool dd {
  height: 100px;
  display: block;
}

.tab {
  width: auto;
}

.tab li {
  margin-left: 10px;
  padding: 1px 8px;
  width: auto;
  color: #333;
  font-size: 12px;
  cursor: pointer;
}

.tab li.active {
  color: #fff;
  border-radius: 6px;
  background: #2d81ff;
}

/* 订单详情样式 */
.order-detail {
  width: 400px;
  margin-right: 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 2px 2px 20px 6px #f0f1f5;
  padding: 20px;
  box-sizing: border-box;
}

.order-info {
  margin-top: 20px;
}

.info-item {
  display: flex;
  margin-bottom: 15px;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-item .label {
  color: #666;
  font-size: 14px;
  min-width: 80px;
  flex-shrink: 0;
}

.info-item .value {
  color: #333;
  font-size: 14px;
  flex: 1;
  word-break: break-all;
}

.info-item .price {
  color: #f56c6c;
  font-weight: bold;
  font-size: 16px;
}

.status {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
}

.status-pending {
  background: #fdf6ec;
  color: #e6a23c;
}

.status-paid {
  background: #f0f9ff;
  color: #409eff;
}

.status-completed {
  background: #f0f9ff;
  color: #67c23a;
}

.status-cancelled {
  background: #fef0f0;
  color: #f56c6c;
}

.status-refunded {
  background: #fef0f0;
  color: #f56c6c;
}

.status-unknown {
  background: #f4f4f5;
  color: #909399;
}

.no-order {
  margin-top: 20px;
  text-align: center;
  padding: 40px 20px;
}

.empty-tip {
  color: #999;
}

.empty-tip i {
  font-size: 48px;
  margin-bottom: 10px;
  display: block;
}

.empty-tip p {
  margin: 0;
  font-size: 14px;
}

.button-group {
  display: flex;
  gap: 8px;
  align-items: center;
}

.button-group .el-button {
  flex: 1;
}
</style>
